import ChartBar from '../components/chartBar';

class ChartBars {
	components: ChartBar[] = [];

	init(container: Document | HTMLElement = document) {
		container.querySelectorAll<HTMLElement>('.hg-chart-bar').forEach((el) => {
			const component = new ChartBar(el);
			component.init();
			this.components.push(component);
		});
	}

	update(container: Document | HTMLElement = document) {
		this.cleanup();
		this.init(container);
	}

	cleanup() {
		this.components.forEach((c) => c.cleanup());
		this.components = [];
	}
}

export default new ChartBars();
